export const environment = {
  production: true,
  isDebugMode: true
};
